import { AxiosError } from "axios";

export const getErrorEnvelopeMessage = (error: unknown): string | null => {
  if (!(error instanceof AxiosError)) {
    return null;
  }

  const message = error.response?.data?.error?.message;

  if (Array.isArray(message)) {
    return message.join(" / ");
  }
  if (typeof message === "string") {
    return message;
  }
  return null;
};

export const isQuotaExceededError = (error: unknown): boolean =>
  error instanceof AxiosError && error.response?.status === 429;
